export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILURE = "GET_FAQ_FAILURE";
export const RESET_FAQ = "RESET_FAQ";

export interface FaqState {
  faqList: any;
  faqSuccess: string | null;
  faqError: string | null;
  faqLoading: boolean;
}

interface GetFaqAction {
  type: typeof GET_FAQ;
  payload: any;
}

interface GetFaqSucess {
  type: typeof GET_FAQ_SUCCESS;
  payload: any;
}

interface GetFaqFailure {
  type: typeof GET_FAQ_FAILURE;
  payload: string;
}

interface ResetFaqAction {
  type: typeof RESET_FAQ;
}

export type FaqActionTypes =
  | GetFaqAction
  | GetFaqSucess
  | GetFaqFailure
  | ResetFaqAction;
